import { render, staticRenderFns } from "./BaseHotspots.vue?vue&type=template&id=db8419f4&"
import script from "./BaseHotspots.vue?vue&type=script&lang=js&"
export * from "./BaseHotspots.vue?vue&type=script&lang=js&"
import style0 from "./BaseHotspots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports